import { Component, ElementRef, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { MuiButtonBaseClass } from './mui-button-base-class';
import { MuiButtonSize } from './mui-button-size.enum';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[mui-btn], a[mui-btn]',
  exportAs: 'muiButton',
  templateUrl: './mui-button.component.html',
  styleUrls: ['../buttons-shared.scss', './mui-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MuiButton extends MuiButtonBaseClass {
  @HostBinding('class')
  get buttonClassList(): string {
    const classList = ['mui-btn', `mui-btn--${this.appearance}`];

    if (this.fullWidth) {
      classList.push('mui-btn--full-width');
    }

    if (MuiButton.isValidEnumValue(MuiButtonSize, this.size)) {
      classList.push(`mui-btn--${this.size}`);
    }

    return classList.join(' ');
  }

  @Input() fullWidth = false;

  constructor(protected el: ElementRef) {
    super(el);
  }
}
